import headerDE from "./affiliate-scheme-de.webp";
import headerEN from "./affiliate-scheme-en.webp";
import section1 from "./business-people-shaking-hands.jpg";
import section2 from "./affiliate-am-laptop-erstellen.png";
import section3 from "./close-up-businesswoman-with-credit-card.jpg";
import section4 from "./agent-sells-house-shake-hand-with-buyer.jpg";
import section5 from "./vereinbahrung-eines-affiliate.jpg";
import section6 from "./affiliates-am-laptop-kreieren.png";

export {
  headerDE,
  headerEN,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
};
